import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-ce068f0a.js';
import './chunk-1f2cfc27.js';
import './chunk-4139443a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-f28f2092.js';
import './chunk-9249d6e5.js';
import './chunk-42f463e6.js';
import './chunk-0f4ba17f.js';
import './chunk-89251f0f.js';
import './chunk-3b7f7d0b.js';
import { D as Datepicker } from './chunk-f19cce82.js';
export { D as BDatepicker } from './chunk-f19cce82.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;
